import React from "react";
import { connect } from "react-redux";

const PageHeader = ({ title }) => {
  return (
    <>
      <div className="page-header no-print">
        <div className="page-title">
          <h3>{title}</h3>
        </div>
      </div>
    </>
  );
};

export default connect(null, {})(PageHeader);
